import { useState } from "react";

const useRowSelection = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const [selectedRows, setSelectedRows] = useState([]);

  const handleCheckboxChange = (event, row) => {
    const orderId = row._id;
    if (event.target.checked) {
      setSelectedRows([...selectedRows, orderId]);
    } else {
      setSelectedRows(selectedRows.filter((_id) => _id !== orderId));
    }
  };

  const handleSelectAll = (event, data) => {
    if (event.target.checked) {
      const allOrderIds = data.map((row) => row._id);
      setSelectedRows(allOrderIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleViewSelected = (data) => {
    const res = data?.filter((row) => selectedRows.includes(row._id));
    return res;
  };

  return {
    selectedRows,
    setSelectedRows,
    handleCheckboxChange,
    handleSelectAll,
    handleViewSelected,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    endIndex,
    startIndex,
  };
};

export default useRowSelection;
